import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { colorService } from "../../Services/color.service";
import { vehicleGroupService } from "../../Services/vehicle.group.service";
import { useDispatch } from "react-redux";
// import {
//     GridComponent,
//     Page,
//     Inject,
//     ColumnDirective,
//     ColumnsDirective,
//     Filter,
// } from "@syncfusion/ej2-react-grids";
import Spinner from "../Components/Spinner";
import { useLocation, useNavigate } from "react-router-dom";
// import ToastError from "../Components/ToastError";
// import DeleteModal from "../Components/Modals/Delete-modal";
// import { select } from "@syncfusion/ej2-base";
import { FaCheck } from "react-icons/fa";
import { IoMdArrowBack } from "react-icons/io";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { IoIosAlert } from "react-icons/io";
import { validateEmail } from "../../Services/string.service";
import { configsService } from "../../Services/configs.service";
import { ToastComponent } from "../Components/ToastComponent";


export default function VehiclesConfig() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { item } = location.state || {};

  const getStorageKey = () => `vehicleConfig_${item?.vehicleGroupId}`;

  const loadStateFromStorage = () => {
    const savedState = localStorage.getItem(getStorageKey());
    if (savedState) {
      return JSON.parse(savedState);
    }
    return {};
  };

  const initialStoredState = loadStateFromStorage();

  const [isLoading, setIsLoading] = useState(true);
  const [listCollor, setListCollor] = useState([]);

  const [selectedColor, setSelectedColor] = useState(
    initialStoredState.selectedColor || ""
  );
  const [selectedId, setSelectedId] = useState(
    initialStoredState.selectedId || ""
  );
  const [group, setGroup] = useState();

  const [kmzFlag, setKmzFlag] = useState(initialStoredState.kmzFlag || false);
  const [fenceFlag, setFenceFlag] = useState(
    initialStoredState.fenceFlag || false
  );
  const [visitFlag, setVisitFlag] = useState(
    initialStoredState.visitFlag || false
  );
  const [riskAreaFlag, setRiskAreaFlag] = useState(
    initialStoredState.riskAreaFlag || false
  );
  const [strechesFlag, setStrechesFlag] = useState(
    initialStoredState.strechesFlag || false
  );
  const [toastParams, setToastParams] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [loadingButtons, setLoadingButtons] = useState({});
  const [refreshEmails, setRefreshEmails] = useState(false);

  const [relatorios, setRelatorios] = useState(
    initialStoredState.relatorios || {
      kmz: false,
      movimentacao: false,
      pontoDeVista: false,
      areaDeRisco: false,
      cercaEletronica: false,
      horario: false,
      velocidade: false,
    }
  );

  const [archives, setArchives] = useState(
    initialStoredState.archives || {
      archiveMovimentacao: "P",
      archivePontoDeVista: "P",
      archiveAreaDeRisco: "P",
      archiveCercaEletronica: "P",
      archiveHorario: "P",
      archiveVelocidade: "P",
    }
  );

  const [movementForm, setMovementForm] = useState(
    initialStoredState.movementForm || {
      weekdays: {
        flag: false,
        start: "08:00",
        end: "18:00",
      },
      saturday: {
        flag: false,
        start: "08:00",
        end: "18:00",
      },
      sunday: {
        flag: false,
        start: "08:00",
        end: "18:00",
      },
      emailNotificationFlag: false,
      attachmentFormat: "pdf",
    }
  );

  const [speedForm, setSpeedForm] = useState(
    initialStoredState.speedForm || {
      urban: {
        flag: false,
        value: "30",
      },
      highway: {
        flag: false,
        value: "30",
      },
      emailNotificationFlag: false,
      attachmentFormat: "P",
    }
  );

  useEffect(() => {
    if (item?.vehicleGroupId) {
      const stateToSave = {
        selectedId,
        selectedColor,
        kmzFlag,
        fenceFlag,
        visitFlag,
        riskAreaFlag,
        strechesFlag,
        relatorios,
        archives,
        movementForm,
        speedForm,
      };
      localStorage.setItem(getStorageKey(), JSON.stringify(stateToSave));
    }
  }, [
    // Lista de dependências: este efeito roda sempre que um desses valores for alterado.
    selectedId,
    selectedColor,
    kmzFlag,
    fenceFlag,
    visitFlag,
    riskAreaFlag,
    strechesFlag,
    relatorios,
    archives,
    movementForm,
    speedForm,
    item,
  ]);

  // Gera o array de opções de 30 a 120 de 10 em 10
  const optionsUrban = [];
  for (let i = 30; i <= 120; i += 10) {
    optionsUrban.push(i);
  }

  const optionsRod = [];
  for (let i = 30; i <= 120; i += 10) {
    optionsRod.push(i);
  }

  const handleToggle = (key) => {
    setRelatorios((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleToggleArchives = (key, value) => {
    setArchives((prev) => ({
      ...prev,
      [key]: value,
    }));

    console.log(archives);
  };

  console.log(item); // agora item existe!

  const initialReports = [
    "velocidade",
    "horario",
    "kmz",
    "movimentacao",
    "pontoDeVista",
    "areaDeRisco",
    "cercaEletronica",
  ];

  const buildInitialState = () => {
    const state = {};
    initialReports.forEach((report, index) => {
      state[report] = {
        vehicleGroupTypeEmailId: index + 1, // 👈 sequencial começando em 1
        email: "",
        list: [],
        error: "",
      };
    });
    return state;
  };

  const [emailsByReport, setEmailsByReport] = useState(buildInitialState);

  const REPORT_TYPES = [
    { key: "velocidade", id: 1 },
    { key: "horario", id: 2 },
    { key: "kmz", id: 3 },
    { key: "movimentacao", id: 4 },
    { key: "pontoDeVista", id: 5 },
    { key: "areaDeRisco", id: 6 },
    { key: "cercaEletronica", id: 7 },
  ];

  useEffect(() => {
    const fetchEmails = async () => {
      try {
        const promises = REPORT_TYPES.map((type) =>
          vehicleGroupService.listEmail(item.vehicleGroupId, type.id)
        );

        const responses = await Promise.all(promises);

        const grouped = {};
        REPORT_TYPES.forEach((type, index) => {
          const emails = Array.isArray(responses[index])
            ? responses[index]
            : [];

          grouped[type.key] = {
            vehicleGroupTypeEmailId: type.id,
            email: "",
            error: "",
            list: emails.map((entry) => ({
              id: entry.emailId,
              email: entry.email,
              isValid: entry.isValid ?? "N",
            })),
          };
        });

        setEmailsByReport(grouped);
      } catch (error) {
        console.error("Erro ao carregar emails:", error);
      }
    };

    if (item?.vehicleGroupId) {
      fetchEmails();
    }

    // 👇 Armazena a função para usar fora
    // (define uma função global dentro do escopo do componente)
    window.fetchEmails = fetchEmails;
  }, [item]);

  //buscar o grupo
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await vehicleGroupService.getGroupById(
          item.vehicleGroupId
        );
        if (response) {
          setGroup(response[0]);
        }
      } catch (error) {
        console.error("Erro ao buscar as grupos:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [item.vehicleGroupId]);

  //buscar as cores
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await colorService.list();
        if (response) {
          setListCollor(response);
        }
      } catch (error) {
        console.error("Erro ao buscar as cores:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    dispatch({ type: "title", value: "Configuração do grupo" });
  }, [dispatch]);

  const handleChangeCollor = (e) => {
    const colorId = e.target.value;
    const colorObj = listCollor.find((c) => c.colorId == colorId);
    setSelectedColor(colorObj?.hex || "");
    setSelectedId(colorId);
  };

  const handleCancel = () => {
    navigate(-1); // 👈 volta para a página anterior
  };

  const onSubmit = async (idColor) => {
    const getFlag = (value) => (value ? "S" : "N");

    setIsSaving(true);
    try {
      const responseColors = await colorService.sendColor(
        Number(idColor),
        group.vehicleGroupId
      );

      const payloadMovement = {
        checkMovWeekdaysFlag: movementForm.weekdays.flag ? "S" : "N",
        checkMovWeekdaysStart: movementForm.weekdays.start,
        checkMovWeekdaysEnd: movementForm.weekdays.end,

        checkMovSaturdayFlag: movementForm.saturday.flag ? "S" : "N",
        checkMovSaturdayStart: movementForm.saturday.start,
        checkMovSaturdayEnd: movementForm.saturday.end,

        checkMovSundayFlag: movementForm.sunday.flag ? "S" : "N",
        checkMovSundayStart: movementForm.sunday.start,
        checkMovSundayEnd: movementForm.sunday.end,

        emailNotificationFlag: movementForm.emailNotificationFlag ? "S" : "N",
        attachmentFormat: movementForm.attachmentFormat,
      };
      const responseMovement = await vehicleGroupService.sendMovement(
        group.vehicleGroupId,
        payloadMovement
      );

      const payloadSpeed = {
        urbanSpeedCheck: speedForm.urban.flag ? "S" : "N",
        urbanSpeedValue: speedForm.urban.value,

        highwaySpeedCheck: speedForm.highway.flag ? "S" : "N",
        highwaySpeedValue: speedForm.highway.value,

        speedEmailCheck: speedForm.emailNotificationFlag ? "S" : "N",
        speedAttachmentFormatCheck: speedForm.attachmentFormat,
      };
      const responseSpeed = await vehicleGroupService.sendSpeed(
        group.vehicleGroupId,
        payloadSpeed
      );

      const payloadKmz = {
        kmzEmailCheck: getFlag(visitFlag),
      };
      const responseKmz = await configsService.sendKmz(
        group.vehicleGroupId,
        payloadKmz
      );

      const payloadVisit = {
        visitEmailCheck: getFlag(visitFlag),
        visitAttachmentFormatCheck: archives.archivePontoDeVista,
      };
      const responseVisit = await configsService.sendVisit(
        group.vehicleGroupId,
        payloadVisit
      );

      const payloadFence = {
        fenceEmailCheck: getFlag(fenceFlag),
        fenceAttachmentFormatCheck: archives.archiveCercaEletronica,
      };
      const responseFence = await configsService.sendFence(
        group.vehicleGroupId,
        payloadFence
      );

      const payloadRiskArea = {
        riskAreaEmailCheck: getFlag(riskAreaFlag),
        riskAreaAttachmentFormatCheck: archives.archiveAreaDeRisco,
      };
      const responseRiskArea = await configsService.sendRiskArea(
        group.vehicleGroupId,
        payloadRiskArea
      );

      const payloadStreches = {
        stretchEmailCheck: getFlag(strechesFlag),
        stretchAttachmentCheck: archives.archiveMovimentacao,
      };
      const responseStreches = await configsService.sendStreches(
        group.vehicleGroupId,
        payloadStreches
      );

      if (
        responseColors &&
        responseSpeed &&
        responseMovement &&
        responseKmz &&
        responseFence &&
        responseVisit &&
        responseRiskArea &&
        responseStreches
      ) {
        setToastParams(
          JSON.stringify({
            show: true,
            title: "Atenção!",
            body: "Configurações atualizadas",
            color: "Success",
          })
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsSaving(false);
    }
  };

  const getEmailContent = (reportKey) => {
    const { email, list, error } = emailsByReport[reportKey] || {
      email: "",
      list: [],
      error: "",
    };

    const handleChange = (e) => {
      setEmailsByReport((prev) => ({
        ...prev,
        [reportKey]: { ...prev[reportKey], email: e.target.value },
      }));
    };

    const handleAdd = async () => {
      const trimmedEmail = email.trim();
      if (!trimmedEmail) return;

      if (!validateEmail(trimmedEmail)) {
        setEmailsByReport((prev) => ({
          ...prev,
          [reportKey]: {
            ...prev[reportKey],
            error: "Digite um e-mail válido.",
          },
        }));
        return;
      }

      if (list.some((e) => e.email === trimmedEmail)) {
        setEmailsByReport((prev) => ({
          ...prev,
          [reportKey]: {
            ...prev[reportKey],
            error: "Este email já foi adicionado.",
          },
        }));
        return;
      }

      setLoadingButtons((prev) => ({ ...prev, [reportKey]: true }));

      try {
        const reportTypeObj = REPORT_TYPES.find((t) => t.key === reportKey);
        if (!reportTypeObj) {
          console.error(`Report key "${reportKey}" não encontrado.`);
          return;
        }

        const payload = {
          vehicleGroupTypeEmailId: reportTypeObj.id,
          email: trimmedEmail,
        };

        await vehicleGroupService.insertEmail(item.vehicleGroupId, payload);
        console.log("E-mail adicionado com sucesso");

        // ✅ Recarrega a lista do backend
        await window.fetchEmails();

        setEmailsByReport((prev) => ({
          ...prev,
          [reportKey]: {
            ...prev[reportKey],
            email: "",
            error: "",
          },
        }));
      } catch (error) {
        console.error("Erro ao adicionar email:", error);
        setEmailsByReport((prev) => ({
          ...prev,
          [reportKey]: {
            ...prev[reportKey],
            error: "Falha ao adicionar e-mail. Tente novamente.",
          },
        }));
      } finally {
        setLoadingButtons((prev) => ({ ...prev, [reportKey]: false }));
      }
    };

    const handleRemove = async (vehicleGroupEmailId) => {
      try {
        // 👇 Chamada para API
        await vehicleGroupService.deleteEmail(
          item.vehicleGroupId,
          vehicleGroupEmailId
        );

        // 👇 Atualiza estado local
        setEmailsByReport((prev) => ({
          ...prev,
          [reportKey]: {
            ...prev[reportKey],
            list: prev[reportKey].list.filter(
              (item) => item.id !== vehicleGroupEmailId
            ),
          },
        }));
      } catch (error) {
        console.error("Erro ao remover email:", error);
        setEmailsByReport((prev) => ({
          ...prev,
          [reportKey]: {
            ...prev[reportKey],
            error: "Falha ao remover e-mail. Tente novamente.",
          },
        }));
      }
    };

    return (
      <div className="row" style={{ marginBottom: 20 }}>
        <div className="col-md-6">
          <label>Email:</label>
          <div className="input-group mb-2">
            <input
              type="email"
              className="form-control"
              value={email}
              onChange={handleChange}
              placeholder="Digite o e-mail"
            />
            <button
              className="btn btn-primary"
              onClick={handleAdd}
              disabled={loadingButtons[reportKey]}
            >
              {loadingButtons[reportKey] ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Inserindo...
                </>
              ) : (
                "Inserir"
              )}
            </button>
          </div>
          <span style={{ color: "red", fontSize: 10 }}>{error}</span>

          <ul className="list-group">
            {list.map((item) => (
              <li
                key={item.id}
                className="list-group-item d-flex align-items-center"
                style={{
                  gap: "16px",
                }}
              >
                <span
                  style={{
                    flex: 1,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {item.email}
                </span>

                {item.isValid === "S" ? (
                  <IoCheckmarkCircleOutline />
                ) : (
                  <AiOutlineExclamationCircle />
                )}
                <button
                  className="btn btn-sm btn-outline-info"
                  onClick={handleAdd}
                >
                  Reenviar
                </button>
                <button
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => handleRemove(item.id)}
                >
                  Excluir
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  };

  return (
    <>
      <ToastComponent
        params={toastParams}
        closeToast={() => setToastParams(JSON.stringify({ show: false }))}
      />
      <div
        style={{
          marginLeft: 10,
          marginRight: 10,
          paddingLeft: 20,
          paddingRight: 20,
          paddingTop: 20,
        }}
      >
        {isLoading ? (
          <Spinner />
        ) : (
          <>
            <div className="back-to-fleet" style={{ marginBottom: 8 }}>
              <button
                style={{ display: "flex", alignItems: "center" }}
                onClick={() => handleCancel()}
              >
                <div className="icon-back-fleet">
                  <IoMdArrowBack />
                </div>
                <span>Voltar</span>
              </button>
            </div>
            <div className="">
              <h3 style={{ color: "var(--text-primary)" }}>
                Configurando grupo: {item.vehicleGroupName}
              </h3>
            </div>
            <div className="row">
              <div className="card col-md-12 p-3">
                <h5 className="mb-3">
                  Cor atribuida a todos os veiculos do grupo
                </h5>
                <div className="col-sm-4 d-flex">
                  <select
                    name="colors"
                    className="form-control me-2"
                    onChange={handleChangeCollor}
                    value={selectedId || "0"}
                  >
                    <option value={"0"}>USAR COR DO VEÍCULO</option>
                    {listCollor &&
                      listCollor.map((color, index) => (
                        <option key={index} value={color.colorId}>
                          {color.description}
                        </option>
                      ))}
                  </select>

                  <div
                    style={{
                      display:
                        selectedId == 0 || !selectedId ? "none" : "block",
                      width: "90px",
                      height: "40px",
                      border: "1px solid #ccc",
                      borderRadius: "6px",
                      backgroundColor: selectedColor || "transparent",
                    }}
                  />
                </div>
              </div>

              {/* O restante do seu JSX permanece o mesmo */}
              <div className="card col-md-12 p-3 mt-3">
                <h5 className="mb-3">
                  Parametrização de sinalização de velocidade definida
                </h5>

                <div className="row align-items-center g-2 mb-2">
                  <div className="col-auto">
                    <div className="form-check form-switch">
                      <label
                        className="form-check-label"
                        htmlFor="switchUrbano"
                      >
                        {" "}
                        Limite de velocidade Urbana
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="switchUrbano"
                        checked={speedForm.urban.flag}
                        onChange={(e) =>
                          setSpeedForm((prev) => ({
                            ...prev,
                            urban: { ...prev.urban, flag: e.target.checked },
                          }))
                        }
                      />
                    </div>
                  </div>
                  <div className="col-auto">
                    <select
                      className="form-control form-control-sm text-center"
                      style={{ width: 50 }}
                      value={speedForm.urban.value}
                      onChange={(e) =>
                        setSpeedForm((prev) => ({
                          ...prev,
                          urban: { ...prev.urban, value: e.target.value },
                        }))
                      }
                    >
                      {optionsUrban.map((num) => (
                        <option key={num} value={num}>
                          {num}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-auto">
                    <span className="text-muted small">Km/h</span>
                  </div>
                </div>

                <div className="row align-items-center g-2 mb-2">
                  <div className="col-auto">
                    <div className="form-check form-switch">
                      <label
                        className="form-check-label"
                        htmlFor="switchRodovia"
                      >
                        Limite de velocidade Rodoviária
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="switchRodovia"
                        checked={speedForm.highway.flag}
                        onChange={(e) =>
                          setSpeedForm((prev) => ({
                            ...prev,
                            highway: {
                              ...prev.highway,
                              flag: e.target.checked,
                            },
                          }))
                        }
                      />
                    </div>
                  </div>
                  <div className="col-auto">
                    <select
                      className="form-control form-control-sm text-center"
                      style={{ width: 45 }}
                      value={speedForm.highway.value}
                      onChange={(e) =>
                        setSpeedForm((prev) => ({
                          ...prev,
                          highway: { ...prev.highway, value: e.target.value },
                        }))
                      }
                    >
                      {optionsRod.map((num) => (
                        <option key={num} value={num}>
                          {num}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-auto">
                    <span className="text-muted small">Km/h</span>
                  </div>
                </div>

                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <div className="form-check form-switch">
                    <label
                      className="form-check-label"
                      htmlFor="switchEmailVelocidade"
                    >
                      {" "}
                      Enviar email sobre excesso de velocidade
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="switchEmailVelocidade"
                      checked={relatorios.velocidade}
                      onChange={(e) => {
                        handleToggle("velocidade");
                        setSpeedForm((prev) => ({
                          ...prev,
                          emailNotificationFlag: e.target.checked
                            ? true
                            : false,
                        }));
                      }}
                    />
                  </div>

                  <div>
                    <select
                      className="form-select"
                      aria-label="Selecione um veículo"
                      value={archives.archiveVelocidade}
                      onChange={(e) => {
                        handleToggleArchives(
                          "archiveVelocidade",
                          e.target.value
                        );
                        setSpeedForm((prev) => ({
                          ...prev,
                          attachmentFormat: e.target.value,
                        }));
                      }}
                    >
                      <option value="P">PDF</option>
                      <option value="X">XLS</option>
                      <option value="H">HTML</option>
                    </select>
                  </div>
                </div>
                {relatorios.velocidade && getEmailContent("velocidade")}
              </div>

              <div className="card col-md-12 p-3 mt-3">
                <h5 className="mb-3">Parametrização de horário de uso</h5>

                <div className="row align-items-center g-2 mb-2">
                  <div className="col-auto">
                    <div className="form-check form-switch">
                      <label className="form-check-label">
                        De Segunda a Sexta
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={movementForm.weekdays.flag}
                        onChange={(e) =>
                          setMovementForm((prev) => ({
                            ...prev,
                            weekdays: {
                              ...prev.weekdays,
                              flag: e.target.checked,
                            },
                          }))
                        }
                      />
                    </div>
                  </div>

                  <div
                    className="col-auto"
                    style={{ marginTop: 5.5, marginLeft: 30 }}
                  >
                    <label className="form-check-label">De:</label>
                  </div>
                  <div className="col-auto d-flex">
                    <input
                      type="time"
                      className="form-control form-control-sm"
                      value={movementForm.weekdays.start}
                      max={movementForm.weekdays.end}
                      onChange={(e) =>
                        setMovementForm((prev) => ({
                          ...prev,
                          weekdays: { ...prev.weekdays, start: e.target.value },
                        }))
                      }
                    />

                    <label
                      className="form-check-label"
                      style={{ margin: "0 10px" }}
                    >
                      Até:
                    </label>

                    <input
                      type="time"
                      className="form-control form-control-sm"
                      value={movementForm.weekdays.end}
                      min={movementForm.weekdays.start}
                      onChange={(e) =>
                        setMovementForm((prev) => ({
                          ...prev,
                          weekdays: { ...prev.weekdays, end: e.target.value },
                        }))
                      }
                    />
                  </div>
                </div>

                <div className="row align-items-center g-2 mb-2">
                  <div className="col-auto">
                    <div className="form-check form-switch">
                      <label className="form-check-label">Sábado</label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={movementForm.saturday.flag}
                        onChange={(e) =>
                          setMovementForm((prev) => ({
                            ...prev,
                            saturday: {
                              ...prev.saturday,
                              flag: e.target.checked,
                            },
                          }))
                        }
                      />
                    </div>
                  </div>

                  <div
                    className="col-auto"
                    style={{ marginTop: 5.5, marginLeft: 30 }}
                  >
                    <label className="form-check-label">De:</label>
                  </div>
                  <div className="col-auto d-flex">
                    <input
                      type="time"
                      className="form-control form-control-sm"
                      value={movementForm.saturday.start}
                      max={movementForm.saturday.end}
                      onChange={(e) =>
                        setMovementForm((prev) => ({
                          ...prev,
                          saturday: { ...prev.saturday, start: e.target.value },
                        }))
                      }
                    />

                    <label
                      className="form-check-label"
                      style={{ margin: "0 10px" }}
                    >
                      Até:
                    </label>

                    <input
                      type="time"
                      className="form-control form-control-sm"
                      value={movementForm.saturday.end}
                      min={movementForm.saturday.start}
                      onChange={(e) =>
                        setMovementForm((prev) => ({
                          ...prev,
                          saturday: { ...prev.saturday, end: e.target.value },
                        }))
                      }
                    />
                  </div>
                </div>

                <div className="row align-items-center g-2 mb-2">
                  <div className="col-auto">
                    <div className="form-check form-switch">
                      <label className="form-check-label">Domingo</label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={movementForm.sunday.flag}
                        onChange={(e) =>
                          setMovementForm((prev) => ({
                            ...prev,
                            sunday: { ...prev.sunday, flag: e.target.checked },
                          }))
                        }
                      />
                    </div>
                  </div>

                  <div
                    className="col-auto"
                    style={{ marginTop: 5.5, marginLeft: 30 }}
                  >
                    <label className="form-check-label">De:</label>
                  </div>
                  <div className="col-auto d-flex">
                    <input
                      type="time"
                      className="form-control form-control-sm"
                      value={movementForm.sunday.start}
                      max={movementForm.sunday.end}
                      onChange={(e) =>
                        setMovementForm((prev) => ({
                          ...prev,
                          sunday: { ...prev.sunday, start: e.target.value },
                        }))
                      }
                    />

                    <label
                      className="form-check-label"
                      style={{ margin: "0 10px" }}
                    >
                      Até:
                    </label>

                    <input
                      type="time"
                      className="form-control form-control-sm"
                      value={movementForm.sunday.end}
                      max={movementForm.sunday.start}
                      onChange={(e) =>
                        setMovementForm((prev) => ({
                          ...prev,
                          sunday: { ...prev.sunday, end: e.target.value },
                        }))
                      }
                    />
                  </div>
                </div>

                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <div className="form-check form-switch">
                    <label
                      className="form-check-label"
                      htmlFor="switchEmailHorario"
                    >
                      Enviar relatório de uso fora do horário permitido
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="switchEmailHorario"
                      checked={relatorios.horario}
                      onChange={(e) => {
                        handleToggle("horario");
                        setMovementForm((prev) => ({
                          ...prev,
                          emailNotificationFlag: e.target.checked
                            ? true
                            : false,
                        }));
                      }}
                    />
                  </div>

                  <div>
                    <select
                      className="form-select"
                      aria-label="Selecione um veículo"
                      value={archives.archiveHorario}
                      onChange={(e) => {
                        handleToggleArchives("archiveHorario", e.target.value);
                        setMovementForm((prev) => ({
                          ...prev,
                          attachmentFormat: e.target.value,
                        }));
                      }}
                    >
                      <option value="P">PDF</option>
                      <option value="X">XLS</option>
                      <option value="H">HTML</option>
                    </select>
                  </div>
                </div>
                {relatorios.horario && getEmailContent("horario")}
              </div>

              <div className="card col-md-12 p-3 mt-3">
                <h5 className="mb-3">Outros Relatórios</h5>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    marginBottom: 10,
                  }}
                >
                  <div className="form-check form-switch">
                    <label className="form-check-label" htmlFor="switchKMZ">
                      Envio diario de arquivo de posicionamento KMZ
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={kmzFlag}
                      id="switchKMZ"
                      onChange={(e) => {
                        handleToggle("kmz");
                        setKmzFlag(e.target.checked);
                      }}
                    />
                  </div>
                </div>

                {relatorios.kmz && getEmailContent("kmz")}

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    marginBottom: 10,
                  }}
                >
                  <div className="form-check form-switch">
                    <label
                      className="form-check-label"
                      htmlFor="switchMovimentacao"
                    >
                      Envio de relatório de movimentação / trecho
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="switchMovimentacao"
                      checked={strechesFlag}
                      onChange={(e) => {
                        handleToggle("movimentacao");
                        setStrechesFlag(e.target.checked);
                      }}
                    />
                  </div>

                  <div style={{ marginLeft: 172 }}>
                    <select
                      className="form-select"
                      aria-label="Selecione um veículo"
                      value={archives.archiveMovimentacao}
                      onChange={(e) =>
                        handleToggleArchives(
                          "archiveMovimentacao",
                          e.target.value
                        )
                      }
                    >
                      <option value="P">PDF</option>
                      <option value="X">XLS</option>
                      <option value="H">HTML</option>
                    </select>
                  </div>
                </div>

                {relatorios.movimentacao && getEmailContent("movimentacao")}

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    marginBottom: 10,
                  }}
                >
                  <div className="form-check form-switch">
                    <label
                      className="form-check-label"
                      htmlFor="switchPontoVista"
                    >
                      Envio de relatório de ponto de visita, controle e passagem
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="switchPontoVista"
                      checked={visitFlag}
                      onChange={(e) => {
                        handleToggle("pontoDeVista");
                        setVisitFlag(e.target.checked);
                      }}
                    />
                  </div>

                  <div style={{ marginLeft: 88 }}>
                    <select
                      className="form-select"
                      aria-label="Selecione um veículo"
                      value={archives.archivePontoDeVista}
                      onChange={(e) => {
                        handleToggleArchives(
                          "archivePontoDeVista",
                          e.target.value
                        );
                      }}
                    >
                      <option value="P">PDF</option>
                      <option value="X">XLS</option>
                      <option value="H">HTML</option>
                    </select>
                  </div>
                </div>

                {relatorios.pontoDeVista && getEmailContent("pontoDeVista")}

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    marginBottom: 10,
                  }}
                >
                  <div className="form-check form-switch">
                    <label
                      className="form-check-label"
                      htmlFor="switchAreaRisco"
                    >
                      Envio de relatório de área de risco
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="switchAreaRisco"
                      checked={riskAreaFlag}
                      onChange={(e) => {
                        handleToggle("areaDeRisco");
                        setRiskAreaFlag(e.target.checked);
                      }}
                    />
                  </div>

                  <div style={{ marginLeft: 245 }}>
                    <select
                      className="form-select"
                      aria-label="Selecione um veículo"
                      value={archives.archiveAreaDeRisco}
                      onChange={(e) =>
                        handleToggleArchives(
                          "archiveAreaDeRisco",
                          e.target.value
                        )
                      }
                    >
                      <option value="P">PDF</option>
                      <option value="X">XLS</option>
                      <option value="H">HTML</option>
                    </select>
                  </div>
                </div>

                {relatorios.areaDeRisco && getEmailContent("areaDeRisco")}

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    marginBottom: 10,
                  }}
                >
                  <div className="form-check form-switch">
                    <label className="form-check-label" htmlFor="switchCerca">
                      Envio de relatório de condução em cerca eletrônica
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="switchCerca"
                      checked={fenceFlag}
                      onChange={(e) => {
                        handleToggle("cercaEletronica");
                        setFenceFlag(e.target.checked);
                      }}
                    />
                  </div>

                  <div style={{ marginLeft: 135 }}>
                    <select
                      className="form-select"
                      aria-label="Selecione um veículo"
                      value={archives.archiveCercaEletronica}
                      onChange={(e) =>
                        handleToggleArchives(
                          "archiveCercaEletronica",
                          e.target.value
                        )
                      }
                    >
                      <option value="P">PDF</option>
                      <option value="X">XLS</option>
                      <option value="H">HTML</option>
                    </select>
                  </div>
                </div>

                {relatorios.cercaEletronica &&
                  getEmailContent("cercaEletronica")}
              </div>
            </div>
            <div
              style={{
                marginTop: 20,
                textAlign: "right",
                display: "flex",
                gap: 16,
                justifyContent: "end",
              }}
            >
              <button
                className="btn btn-secondary"
                onClick={() => handleCancel()}
              >
                Cancelar
              </button>
              <button
                className="btn btn-primary"
                onClick={() => onSubmit(selectedId)}
                disabled={isSaving}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Salvando...
                  </>
                ) : (
                  t("BUTTONS.SAVE")
                )}
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
}